import React, { Fragment } from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import Header from './components/Header';
import Main from './components/Main';
import SinglePage from './components/SinglePage';
import About from './components/About';
import Footer from './components/Footer';
import NotFound from './components/NotFound';

import focus from './focus.json';

import './main.css';

function App() {
  let focusData = focus.filter(
    fdata =>
      fdata.ehraf ||
      fdata.sccs ||
      fdata.ea ||
      fdata.ea_sum ||
      fdata.awc ||
      fdata.srs ||
      fdata.psf ||
      fdata.ses ||
      fdata.wes ||
      fdata.fiche
  );

  return (
    <Router>
      <Fragment>
        <Header />
        <Switch>
          <Route
            exact
            path='/'
            component={() => <Main focusData={focusData} />}
          />
          <Route
            exact
            path='/profile/:id'
            component={props => <SinglePage {...props} focusData={focusData} />}
          />
          <Route exact path='/about' component={() => <About />} />
          <Route component={NotFound} />
        </Switch>
        <Footer />
      </Fragment>
    </Router>
  );
}

export default App;
